import { render, staticRenderFns } from "./PosList.vue?vue&type=template&id=bb1f06b2&scoped=true"
import script from "./PosList.vue?vue&type=script&lang=js"
export * from "./PosList.vue?vue&type=script&lang=js"
import style0 from "./PosList.vue?vue&type=style&index=0&id=bb1f06b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1f06b2",
  null
  
)

export default component.exports